import { YStack } from '@/components/ui/layout/layout';
import { Tooltip } from '@/components/ui/Tooltip';

const VISIBLE_VALUES = 2;

export const ListCell = ({ values }: { values: string[] }) => {
  if (values.length === 0) {
    return <span className="text-foreground-subtle">—</span>;
  }

  const hidden = values.slice(VISIBLE_VALUES);

  return (
    <YStack className="min-w-0 items-start">
      {values.slice(0, VISIBLE_VALUES).map((value) => (
        <span key={value} className="max-w-full truncate">
          {value}
        </span>
      ))}
      {hidden.length > 0 && (
        <Tooltip
          label={hidden.join('\n')}
          side="bottom"
          delayDuration={200}
          className="whitespace-pre-line"
        >
          <span className="cursor-default text-foreground-subtle">
            +{hidden.length}
          </span>
        </Tooltip>
      )}
    </YStack>
  );
};
